<script setup lang="ts">
import { defineProps, defineEmits } from "vue";

type Props = {
  radioValue: any;
  commentValue: any;
  options: Array<string>;
  text: string;
  disabled?: boolean;
  inputClass?: string;
};

type Emits = {
  (event: "updateRadio", radioValue: any): void;
  (event: "updateComment", commentValue: any): void;
};

const props = defineProps<Props>();
const emits = defineEmits<Emits>();

const onRadioValueChange = (radioValue: any) => {
  emits("updateRadio", radioValue);
};

const onCommentValueChange = (event: Event) => {
  const target = event.target as HTMLTextAreaElement;

  emits("updateComment", target.value);
};
</script>

<template>
  <div
    class="flex gap-5 bg-transparent p-2 rounded-primary-radius border"
    :class="inputClass"
  >
    <!-- Left side -->
    <div class="w-[67%]">
      <p
        class="text-base leading-[26px] tracking-[0.01rem] font-medium text-primary-text-color"
      >
        {{ text }}
      </p>
      <!-- Radio buttons -->
      <div
        class="mt-[12px] flex items-center gap-3 flex-wrap"
        role="radiogroup"
      >
        <div v-for="option in options" :key="option">
          <div
            class="custom-radio-button flex items-center justify-between rounded-full py-[2px] px-2 border-2"
            :class="`${
              props.radioValue === option
                ? 'bg-[#DDDDFB] border-transparent'
                : 'bg-transparent border-primary-text-color'
            }
              ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}
            `"
          >
            <input
              :disabled="disabled"
              @change="onRadioValueChange(option)"
              type="radio"
              :checked="props.radioValue === option"
            />
            <div class="flex items-center">
              <img
                v-show="props.radioValue === option"
                src="@/assets/double-circle-radio-icon.svg"
                alt="Circle radio"
              />
              <img
                v-show="props.radioValue !== option"
                src="@/assets/circle-radio-icon.svg"
                alt=""
              />
              <p class="pl-2 text-sm font-normal text-primary-text-color">
                {{ option }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Right side -->
    <textarea
      :disabled="disabled"
      :value="props.commentValue"
      @input="onCommentValueChange"
      placeholder="Kommentar(Optional)"
      class="w-[33%] text-primary-text-color text-base leading-[26px] tracking-[0.01rem] font-normal bg-[#F9F8F6] p-3 border border-[#E3E1EA] rounded-primary-radius resize-none outline-none focus:border focus:border-[#393840]"
    ></textarea>
  </div>
</template>
